import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

// http://specification.sifassociation.org/Implementation/AU/3.4.5/CodeSets.html#AUCodeSetsAustralianStandardClassificationOfLanguagesASCLType
export default BaseEnum.create({
  values: [
    { value: '0000', label: 'Inadequately Described' },
    { value: '0001', label: 'Non Verbal, so described' },
    { value: '0002', label: 'Not Stated' },
    { value: '0003', label: 'Swiss, so described' },
    { value: '0004', label: 'Cypriot, so described' },
    { value: '0005', label: 'Creole, nfd' },
    { value: '0006', label: 'French Creole, nfd' },
    { value: '0007', label: 'Spanish Creole, nfd' },
    { value: '0008', label: 'Portuguese Creole, nfd' },
    { value: '0009', label: 'Pidgin, nfd' },
    { value: '1000', label: 'Northern European Languages, nfd' },
    { value: '1100', label: 'Celtic, nfd' },
    { value: '1101', label: 'Gaelic (Scotland)' },
    { value: '1102', label: 'Irish' },
    { value: '1103', label: 'Welsh' },
    { value: '1199', label: 'Celtic, nec' },
    { value: '1201', label: 'English' },
    { value: '1300', label: 'German and Related Languages, nfd' },
    { value: '1301', label: 'German' },
    { value: '1302', label: 'Letzeburgish' },
    { value: '1303', label: 'Yiddish' },
    { value: '1400', label: 'Dutch and Related Languages, nfd' },
    { value: '1401', label: 'Dutch' },
    { value: '1402', label: 'Frisian' },
    { value: '1403', label: 'Afrikaans' },
    { value: '1500', label: 'Scandinavian, nfd' },
    { value: '1501', label: 'Danish' },
    { value: '1502', label: 'Icelandic' },
    { value: '1503', label: 'Norwegian' },
    { value: '1504', label: 'Swedish' },
    { value: '1599', label: 'Scandinavian, nec' },
    { value: '1600', label: 'Finnish and Related Languages, nfd' },
    { value: '1601', label: 'Estonian' },
    { value: '1602', label: 'Finnish' },
    { value: '1699', label: 'Finnish and Related Languages, nec' },
    { value: '2000', label: 'Southern European Languages, nfd' },
    { value: '2101', label: 'French' },
    { value: '2201', label: 'Greek' },
    { value: '2300', label: 'Iberian Romance, nfd' },
    { value: '2301', label: 'Catalan' },
    { value: '2302', label: 'Portuguese' },
    { value: '2303', label: 'Spanish' },
    { value: '2399', label: 'Iberian Romance, nec' },
    { value: '2401', label: 'Italian' },
    { value: '2501', label: 'Maltese' },
    { value: '2900', label: 'Other Southern European Languages, nfd' },
    { value: '2901', label: 'Basque' },
    { value: '2902', label: 'Latin' },
    { value: '2999', label: 'Other Southern European Languages, nec' },
    { value: '3000', label: 'Eastern European Languages, nfd' },
    { value: '3100', label: 'Baltic, nfd' },
    { value: '3101', label: 'Latvian' },
    { value: '3102', label: 'Lithuanian' },
    { value: '3301', label: 'Hungarian' },
    { value: '3400', label: 'East Slavic, nfd' },
    { value: '3401', label: 'Belorussian' },
    { value: '3402', label: 'Russian' },
    { value: '3403', label: 'Ukrainian' },
    { value: '3500', label: 'South Slavic, nfd' },
    { value: '3501', label: 'Bosnian' },
    { value: '3502', label: 'Bulgarian' },
    { value: '3503', label: 'Croatian' },
    { value: '3504', label: 'Macedonian' },
    { value: '3505', label: 'Serbian' },
    { value: '3506', label: 'Slovene' },
    { value: '3507', label: 'Serbo-Croatian/Yugoslavian, so described' },
    { value: '3600', label: 'West Slavic, nfd' },
    { value: '3601', label: 'Czech' },
    { value: '3602', label: 'Polish' },
    { value: '3603', label: 'Slovak' },
    { value: '3604', label: 'Czechoslovakian, so described' },
    { value: '3900', label: 'Other Eastern European Languages, nfd' },
    { value: '3901', label: 'Albanian' },
    { value: '3903', label: 'Aromunian (Macedo-Romanian)' },
    { value: '3904', label: 'Romanian' },
    { value: '3905', label: 'Romany' },
    { value: '3999', label: 'Other Eastern European Languages, nec' },
    { value: '4000', label: 'Southwest and Central Asian Languages, nfd' },
    { value: '4100', label: 'Iranic, nfd' },
    { value: '4101', label: 'Kurdish' },
    { value: '4102', label: 'Pashto' },
    { value: '4104', label: 'Balochi' },
    { value: '4105', label: 'Dari' },
    { value: '4106', label: 'Persian (excluding Dari)' },
    { value: '4107', label: 'Hazaraghi' },
    { value: '4199', label: 'Iranic, nec' },
    { value: '4200', label: 'Middle Eastern Semitic Languages, nfd' },
    { value: '4202', label: 'Arabic' },
    { value: '4204', label: 'Hebrew' },
    { value: '4206', label: 'Assyrian Neo-Aramaic' },
    { value: '4207', label: 'Chaldean Neo-Aramaic' },
    { value: '4208', label: 'Mandaean (Mandaic)' },
    { value: '4299', label: 'Middle Eastern Semitic Languages, nec' },
    { value: '4300', label: 'Turkic, nfd' },
    { value: '4301', label: 'Turkish' },
    { value: '4302', label: 'Azeri' },
    { value: '4303', label: 'Tatar' },
    { value: '4304', label: 'Turkmen' },
    { value: '4305', label: 'Uygur' },
    { value: '4306', label: 'Uzbek' },
    { value: '4399', label: 'Turkic, nec' },
    {
      value: '4900',
      label: 'Other Southwest and Central Asian Languages, nfd',
    },
    { value: '4901', label: 'Armenian' },
    { value: '4902', label: 'Georgian' },
    {
      value: '4999',
      label: 'Other Southwest and Central Asian Languages, nec',
    },
    { value: '5000', label: 'Southern Asian Languages, nfd' },
    { value: '5100', label: 'Dravidian, nfd' },
    { value: '5101', label: 'Kannada' },
    { value: '5102', label: 'Malayalam' },
    { value: '5103', label: 'Tamil' },
    { value: '5104', label: 'Telugu' },
    { value: '5105', label: 'Tulu' },
    { value: '5199', label: 'Dravidian, nec' },
    { value: '5200', label: 'Indo-Aryan, nfd' },
    { value: '5201', label: 'Bengali' },
    { value: '5202', label: 'Gujarati' },
    { value: '5203', label: 'Hindi' },
    { value: '5204', label: 'Konkani' },
    { value: '5205', label: 'Marathi' },
    { value: '5206', label: 'Nepali' },
    { value: '5207', label: 'Punjabi' },
    { value: '5208', label: 'Sindhi' },
    { value: '5211', label: 'Sinhalese' },
    { value: '5212', label: 'Urdu' },
    { value: '5213', label: 'Assamese' },
    { value: '5214', label: 'Dhivehi' },
    { value: '5215', label: 'Kashmiri' },
    { value: '5216', label: 'Oriya' },
    { value: '5217', label: 'Fijian Hindustani' },
    { value: '5299', label: 'Indo-Aryan, nec' },
    { value: '5999', label: 'Other Southern Asian Languages' },
    { value: '6000', label: 'Southeast Asian Languages, nfd' },
    { value: '6100', label: 'Burmese and Related Languages, nfd' },
    { value: '6101', label: 'Burmese' },
    { value: '6102', label: 'Chin Haka' },
    { value: '6103', label: 'Karen' },
    { value: '6104', label: 'Rohingya' },
    { value: '6105', label: 'Zomi' },
    { value: '6199', label: 'Burmese and Related Languages, nec' },
    { value: '6200', label: 'Hmong-Mien, nfd' },
    { value: '6201', label: 'Hmong' },
    { value: '6299', label: 'Hmong-Mien, nec' },
    { value: '6300', label: 'Mon-Khmer, nfd' },
    { value: '6301', label: 'Khmer' },
    { value: '6302', label: 'Vietnamese' },
    { value: '6303', label: 'Mon' },
    { value: '6399', label: 'Mon-Khmer, nec' },
    { value: '6400', label: 'Tai, nfd' },
    { value: '6401', label: 'Lao' },
    { value: '6402', label: 'Thai' },
    { value: '6499', label: 'Tai, nec' },
    { value: '6500', label: 'Southeast Asian Austronesian Languages, nfd' },
    { value: '6501', label: 'Bisaya' },
    { value: '6502', label: 'Cebuano' },
    { value: '6503', label: 'IIokano' },
    { value: '6504', label: 'Indonesian' },
    { value: '6505', label: 'Malay' },
    { value: '6507', label: 'Tetum' },
    { value: '6508', label: 'Timorese' },
    { value: '6511', label: 'Tagalog' },
    { value: '6512', label: 'Filipino' },
    { value: '6513', label: 'Acehnese' },
    { value: '6514', label: 'Balinese' },
    { value: '6515', label: 'Bikol' },
    { value: '6516', label: 'Iban' },
    { value: '6517', label: 'Ilonggo (Hiligaynon)' },
    { value: '6518', label: 'Javanese' },
    { value: '6521', label: 'Pampangan' },
    { value: '6599', label: 'Southeast Asian Austronesian Languages, nec' },
    { value: '6999', label: 'Other Southeast Asian Languages' },
    { value: '7000', label: 'Eastern Asian Languages, nfd' },
    { value: '7100', label: 'Chinese, nfd' },
    { value: '7101', label: 'Cantonese' },
    { value: '7102', label: 'Hakka' },
    { value: '7104', label: 'Mandarin' },
    { value: '7106', label: 'Wu' },
    { value: '7107', label: 'Min Nan' },
    { value: '7199', label: 'Chinese, nec' },
    { value: '7201', label: 'Japanese' },
    { value: '7301', label: 'Korean' },
    { value: '7900', label: 'Other Eastern Asian Languages, nfd' },
    { value: '7901', label: 'Tibetan' },
    { value: '7902', label: 'Mongolian' },
    { value: '7999', label: 'Other Eastern Asian Languages, nec' },
    { value: '8000', label: 'Australian Indigenous Languages, nfd' },
    {
      value: '8100',
      label: 'Arnhem Land and Daly River Region Languages, nfd',
    },
    { value: '8101', label: 'Anindilyakwa' },
    { value: '8111', label: 'Maung' },
    { value: '8113', label: "Ngan'gikurunggurr" },
    { value: '8114', label: 'Nunggubuyu' },
    { value: '8115', label: 'Rembarrnga' },
    { value: '8117', label: 'Tiwi' },
    { value: '8121', label: 'Alawa' },
    { value: '8122', label: 'Dalabon' },
    { value: '8123', label: 'Gudanji' },
    { value: '8127', label: 'Iwaidja' },
    { value: '8128', label: 'Jaminjung' },
    { value: '8131', label: 'Jawoyn' },
    { value: '8132', label: 'Jingulu' },
    { value: '8133', label: 'Kunbarlang' },
    { value: '8136', label: 'Larrakiya' },
    { value: '8137', label: 'Malak Malak' },
    { value: '8138', label: 'Mangarrayi' },
    { value: '8141', label: 'Maringarr' },
    { value: '8142', label: 'Marra' },
    { value: '8143', label: 'Marrithiyel' },
    { value: '8144', label: 'Matngala' },
    { value: '8146', label: 'Murrinh Patha' },
    { value: '8147', label: 'Na-kara' },
    { value: '8148', label: 'Ndjebbana (Gunavidji)' },
    { value: '8151', label: 'Ngalakgan' },
    { value: '8152', label: 'Ngaliwurru' },
    { value: '8153', label: 'Nungali' },
    { value: '8154', label: 'Wambaya' },
    { value: '8155', label: 'Wardaman' },
    { value: '8156', label: 'Amurdak' },
    { value: '8157', label: 'Garrwa' },
    { value: '8158', label: 'Kuwema' },
    { value: '8161', label: 'Marramaninyshi' },
    { value: '8162', label: 'Ngandi' },
    { value: '8163', label: 'Waanyi' },
    { value: '8164', label: 'Wagiman' },
    { value: '8165', label: 'Yanyuwa' },
    { value: '8166', label: 'Marridan (Maridan)' },
    { value: '8170', label: 'Kunwinjkuan, nfd' },
    { value: '8171', label: 'Gundjeihmi' },
    { value: '8172', label: 'Kune' },
    { value: '8173', label: 'Kuninjku' },
    { value: '8174', label: 'Kunwinjku' },
    { value: '8175', label: 'Mayali' },
    { value: '8179', label: 'Kunwinjkuan, nec' },
    { value: '8180', label: 'Burarran, nfd' },
    { value: '8181', label: 'Burarra' },
    { value: '8182', label: 'Gun-nartpa' },
    { value: '8183', label: 'Gurr-goni' },
    { value: '8189', label: 'Burarran, nec' },
    {
      value: '8199',
      label: 'Arnhem Land and Daly River Region Languages, nec',
    },
    { value: '8200', label: 'Yolngu Matha, nfd' },
    { value: '8210', label: 'Dhangu, nfd' },
    { value: '8211', label: 'Galpu' },
    { value: '8212', label: 'Golumala' },
    { value: '8213', label: 'Wangurri' },
    { value: '8219', label: 'Dhangu, nec' },
    { value: '8220', label: "Dhay'yi, nfd" },
    { value: '8221', label: 'Dhalwangu' },
    { value: '8222', label: 'Djarrwark' },
    { value: '8229', label: "Dhay'yi, nec" },
    { value: '8230', label: 'Dhuwal, nfd' },
    { value: '8231', label: 'Djambarrpuyngu' },
    { value: '8232', label: 'Djapu' },
    { value: '8233', label: 'Daatiwuy' },
    { value: '8234', label: 'Marrangu' },
    { value: '8235', label: 'Liyagalawumirr' },
    { value: '8236', label: 'Liyagawumirr' },
    { value: '8239', label: 'Dhuwal, nec' },
    { value: '8240', label: 'Dhuwala, nfd' },
    { value: '8242', label: 'Gumatj' },
    { value: '8243', label: 'Gupapuyngu' },
    { value: '8244', label: 'Guyamirrilili' },
    { value: '8246', label: 'Manggalili' },
    { value: '8247', label: 'Wubulkarra' },
    { value: '8249', label: 'Dhuwala, nec' },
    { value: '8250', label: 'Djinang, nfd' },
    { value: '8251', label: 'Wurlaki' },
    { value: '8259', label: 'Djinang, nec' },
    { value: '8260', label: 'Djinba, nfd' },
    { value: '8261', label: 'Ganalbingu' },
    { value: '8262', label: 'Djinba' },
    { value: '8263', label: 'Manyjalpingu' },
    { value: '8269', label: 'Djinba, nec' },
    { value: '8270', label: 'Yakuy, nfd' },
    { value: '8271', label: 'Ritharrngu' },
    { value: '8272', label: 'Wagilak' },
    { value: '8279', label: 'Yakuy, nec' },
    { value: '8281', label: 'Nhangu' },
    { value: '8282', label: 'Yan-nhangu' },
    { value: '8289', label: 'Nhangu, nec' },
    { value: '8291', label: 'Dhuwaya' },
    { value: '8292', label: 'Djangu' },
    { value: '8293', label: 'Madarrpa' },
    { value: '8294', label: 'Warramiri' },
    { value: '8295', label: 'Rirratjingu' },
    { value: '8299', label: 'Other Yolngu Matha, nec' },
    { value: '8300', label: 'Cape York Peninsula Languages, nfd' },
    { value: '8301', label: 'Kuku Yalanji' },
    { value: '8302', label: 'Guugu Yimidhirr' },
    { value: '8303', label: "Kuuku-Ya'u" },
    { value: '8304', label: 'Wik Mungkan' },
    { value: '8305', label: 'Djabugay' },
    { value: '8306', label: 'Dyirbal' },
    { value: '8307', label: 'Girramay' },
    { value: '8308', label: 'Koko-Bera' },
    { value: '8311', label: 'Kuuk Thayorre' },
    { value: '8312', label: 'Lamalama' },
    { value: '8313', label: 'Yidiny' },
    { value: '8314', label: 'Wik Ngathan' },
    { value: '8315', label: 'Alngith' },
    { value: '8316', label: 'Kugu Muminh' },
    { value: '8317', label: 'Morrobalama' },
    { value: '8318', label: 'Thaynakwith' },
    { value: '8321', label: 'Yupangathi' },
    { value: '8322', label: 'Tjungundji' },
    { value: '8399', label: 'Cape York Peninsula Languages, nec' },
    { value: '8400', label: 'Torres Strait Island Languages, nfd' },
    { value: '8401', label: 'Kalaw Kawaw Ya/Kalaw Lagaw Ya' },
    { value: '8402', label: 'Meriam Mir' },
    { value: '8403', label: 'Yumplatok (Torres Strait Creole)' },
    { value: '8500', label: 'Northern Desert Fringe Area Languages, nfd' },
    { value: '8504', label: 'Bilinarra' },
    { value: '8505', label: 'Gurindji' },
    { value: '8506', label: 'Gurindji Kriol' },
    { value: '8507', label: 'Jaru' },
    { value: '8508', label: 'Light Warlpiri' },
    { value: '8511', label: 'Malngin' },
    { value: '8512', label: 'Mudburra' },
    { value: '8514', label: 'Ngardi' },
    { value: '8515', label: 'Ngarinyman' },
    { value: '8516', label: 'Walmajarri' },
    { value: '8517', label: 'Wanyjirra' },
    { value: '8518', label: 'Warlmanpa' },
    { value: '8521', label: 'Warlpiri' },
    { value: '8522', label: 'Warumungu' },
    { value: '8599', label: 'Northern Desert Fringe Area Languages, nec' },
    { value: '8600', label: 'Arandic, nfd' },
    { value: '8603', label: 'Alyawarr' },
    { value: '8606', label: 'Kaytetye' },
    { value: '8607', label: 'Antekerrepenh' },
    { value: '8610', label: 'Anmatyerr, nfd' },
    { value: '8611', label: 'Central Anmatyerr' },
    { value: '8612', label: 'Eastern Anmatyerr' },
    { value: '8619', label: 'Anmatyerr, nec' },
    { value: '8620', label: 'Arrernte, nfd' },
    { value: '8621', label: 'Eastern Arrernte' },
    { value: '8622', label: 'Western Arrarnta' },
    { value: '8629', label: 'Arrernte, nec' },
    { value: '8699', label: 'Arandic, nec' },
    { value: '8700', label: 'Western Desert Languages, nfd' },
    { value: '8703', label: 'Antikarinya' },
    { value: '8704', label: 'Kartujarra' },
    { value: '8705', label: 'Kukatha' },
    { value: '8706', label: 'Kukatja' },
    { value: '8707', label: 'Luritja' },
    { value: '8708', label: 'Manyjilyjarra' },
    { value: '8711', label: 'Martu Wangka' },
    { value: '8712', label: 'Ngaanyatjarra' },
    { value: '8713', label: 'Pintupi' },
    { value: '8714', label: 'Pitjantjatjara' },
    { value: '8715', label: 'Wangkajunga' },
    { value: '8716', label: 'Wangkatha' },
    { value: '8717', label: 'Warnman' },
    { value: '8718', label: 'Yankunytjatjara' },
    { value: '8721', label: 'Yulparija' },
    { value: '8722', label: 'Tjupany' },
    { value: '8799', label: 'Western Desert Languages, nec' },
    { value: '8800', label: 'Kimberley Area Languages, nfd' },
    { value: '8801', label: 'Bardi' },
    { value: '8802', label: 'Bunuba' },
    { value: '8803', label: 'Gooniyandi' },
    { value: '8804', label: 'Miriwoong' },
    { value: '8805', label: 'Ngarinyin' },
    { value: '8806', label: 'Nyikina' },
    { value: '8807', label: 'Worla' },
    { value: '8808', label: 'Worrorra' },
    { value: '8811', label: 'Wunambal' },
    { value: '8812', label: 'Yawuru' },
    { value: '8813', label: 'Gambera' },
    { value: '8814', label: 'Jawi' },
    { value: '8815', label: 'Kija' },
    { value: '8899', label: 'Kimberley Area Languages, nec' },
    { value: '8900', label: 'Other Australian Indigenous Languages, nfd' },
    { value: '8901', label: 'Adnymathanha' },
    { value: '8902', label: 'Arabana' },
    { value: '8903', label: 'Bandjalang' },
    { value: '8904', label: 'Banyjima' },
    { value: '8905', label: 'Batjala' },
    { value: '8906', label: 'Bidjara' },
    { value: '8907', label: 'Dhanggatti' },
    { value: '8908', label: 'Diyari' },
    { value: '8911', label: 'Gamilaraay' },
    { value: '8913', label: 'Garuwali' },
    { value: '8914', label: 'Githabul' },
    { value: '8915', label: 'Gumbaynggir' },
    { value: '8916', label: 'Kanai' },
    { value: '8917', label: 'Karajarri' },
    { value: '8918', label: 'Kariyarra' },
    { value: '8921', label: 'Kaurna' },
    { value: '8922', label: 'Kayardild' },
    { value: '8924', label: 'Kriol' },
    { value: '8925', label: 'Lardil' },
    { value: '8926', label: 'Mangala' },
    { value: '8927', label: 'Muruwari' },
    { value: '8928', label: 'Narungga' },
    { value: '8931', label: 'Ngarluma' },
    { value: '8932', label: 'Ngarrindjeri' },
    { value: '8933', label: 'Nyamal' },
    { value: '8934', label: 'Nyangumarta' },
    { value: '8935', label: 'Nyungar' },
    { value: '8936', label: 'Paakantyi' },
    { value: '8937', label: 'Palyku/Nyiyaparli' },
    { value: '8938', label: 'Wajarri' },
    { value: '8941', label: 'Wiradjuri' },
    { value: '8943', label: 'Yindjibarndi' },
    { value: '8944', label: 'Yinhawangka' },
    { value: '8945', label: 'Yorta Yorta' },
    { value: '8946', label: 'Baanbay' },
    { value: '8947', label: 'Badimaya' },
    { value: '8948', label: 'Barababaraba' },
    { value: '8951', label: 'Dadi Dadi' },
    { value: '8952', label: 'Dharawal' },
    { value: '8953', label: 'Djabwurrung' },
    { value: '8954', label: 'Gudjal' },
    { value: '8955', label: 'Keerray-Woorroong' },
    { value: '8956', label: 'Ladji Ladji' },
    { value: '8957', label: 'Mirning' },
    { value: '8958', label: 'Ngatjumaya' },
    { value: '8961', label: 'Waluwarra' },
    { value: '8962', label: 'Wangkangurru' },
    { value: '8963', label: 'Wargamay' },
    { value: '8964', label: 'Wergaia' },
    { value: '8965', label: 'Yugambeh' },
    { value: '8998', label: 'Aboriginal English, so described' },
    { value: '8999', label: 'Other Australian Indigenous Languages, nec' },
    { value: '9000', label: 'Other Languages, nfd' },
    { value: '9101', label: 'American Languages' },
    { value: '9200', label: 'African Languages, nfd' },
    { value: '9201', label: 'Acholi' },
    { value: '9203', label: 'Akan' },
    { value: '9205', label: 'Mauritian Creole' },
    { value: '9206', label: 'Oromo' },
    { value: '9207', label: 'Shona' },
    { value: '9208', label: 'Somali' },
    { value: '9211', label: 'Swahili' },
    { value: '9212', label: 'Yoruba' },
    { value: '9213', label: 'Zulu' },
    { value: '9214', label: 'Amharic' },
    { value: '9215', label: 'Bemba' },
    { value: '9216', label: 'Dinka' },
    { value: '9217', label: 'Ewe' },
    { value: '9218', label: 'Ga' },
    { value: '9221', label: 'Harari' },
    { value: '9222', label: 'Hausa' },
    { value: '9223', label: 'Igbo' },
    { value: '9224', label: 'Kikuyu' },
    { value: '9225', label: 'Krio' },
    { value: '9226', label: 'Luganda' },
    { value: '9227', label: 'Luo' },
    { value: '9228', label: 'Ndebele' },
    { value: '9231', label: 'Nuer' },
    { value: '9232', label: 'Nyanja (Chichewa)' },
    { value: '9233', label: 'Shilluk' },
    { value: '9234', label: 'Tigre' },
    { value: '9235', label: 'Tigrinya' },
    { value: '9236', label: 'Tswana' },
    { value: '9237', label: 'Xhosa' },
    { value: '9238', label: 'Seychelles Creole' },
    { value: '9241', label: 'Anuak' },
    { value: '9242', label: 'Bari' },
    { value: '9243', label: 'Bassa' },
    { value: '9244', label: 'Dan (Gio-Dan)' },
    { value: '9245', label: 'Fulfulde' },
    { value: '9246', label: 'Kinyarwanda (Rwanda)' },
    { value: '9247', label: 'Kirundi (Rundi)' },
    { value: '9248', label: 'Kpelle' },
    { value: '9251', label: 'Krahn' },
    { value: '9252', label: 'Liberian (Liberian English)' },
    { value: '9253', label: 'Loma (Lorma)' },
    { value: '9254', label: 'Lumun (Kuku Lumun)' },
    { value: '9255', label: 'Madi' },
    { value: '9256', label: 'Mandinka' },
    { value: '9257', label: 'Mann' },
    { value: '9258', label: 'Moro (Nuba Moro)' },
    { value: '9261', label: 'Themne' },
    { value: '9262', label: 'Lingala' },
    { value: '9299', label: 'African Languages, nec' },
    { value: '9300', label: 'Pacific Austronesian Languages, nfd' },
    { value: '9301', label: 'Fijian' },
    { value: '9302', label: 'Gilbertese' },
    { value: '9303', label: 'Maori (Cook Island)' },
    { value: '9304', label: 'Maori (New Zealand)' },
    { value: '9306', label: 'Nauruan' },
    { value: '9307', label: 'Niue' },
    { value: '9308', label: 'Samoan' },
    { value: '9311', label: 'Tongan' },
    { value: '9312', label: 'Rotuman' },
    { value: '9313', label: 'Tokelauan' },
    { value: '9314', label: 'Tuvaluan' },
    { value: '9315', label: 'Yapese' },
    { value: '9399', label: 'Pacific Austronesian Languages, nec' },
    { value: '9400', label: 'Oceanic Pidgins and Creoles, nfd' },
    { value: '9402', label: 'Bislama' },
    { value: '9403', label: 'Hawaiian English' },
    { value: '9404', label: "Norf'k-Pitcairn" },
    { value: '9405', label: 'Solomon Islands Pijin' },
    { value: '9499', label: 'Oceanian Pidgins and Creoles, nec' },
    { value: '9500', label: 'Papua New Guinea Languages, nfd' },
    { value: '9502', label: 'Kiwai' },
    { value: '9503', label: 'Motu (HiriMotu)' },
    { value: '9504', label: 'Tok Pisin (Neomelanesian)' },
    { value: '9599', label: 'Papua New Guinea Languages, nec' },
    { value: '9601', label: 'Invented Languages' },
    { value: '9700', label: 'Sign Languages, nfd' },
    { value: '9701', label: 'Auslan' },
    { value: '9702', label: 'Key Word Sign Australia' },
    { value: '9799', label: 'Sign Languages, nec' },
  ],
});
